import { addCollection } from '@iconify/vue';
import { icons as remixIcons } from '@iconify-json/ri';

addCollection(remixIcons);

export const riIconMap = {
  add: 'ri:add-line',
  admin: 'ri:admin-line',
  ai: 'ri:sparkling-2-line',
  app: 'ri:apps-2-line',
  arrowLeft: 'ri:arrow-left-line',
  arrowRight: 'ri:arrow-right-line',
  audio: 'ri:volume-up-line',
  back: 'ri:arrow-go-back-line',
  check: 'ri:check-line',
  checkCircle: 'ri:checkbox-circle-line',
  celebration: 'ri:medal-line',
  clock: 'ri:time-line',
  close: 'ri:close-line',
  closeCircle: 'ri:close-circle-line',
  copy: 'ri:file-copy-line',
  credits: 'ri:coins-line',
  delete: 'ri:delete-bin-6-line',
  download: 'ri:download-2-line',
  drag: 'ri:draggable',
  dropdown: 'ri:arrow-down-s-line',
  edit: 'ri:edit-line',
  empty: 'ri:inbox-line',
  error: 'ri:error-warning-line',
  favorite: 'ri:heart-line',
  feedback: 'ri:message-3-line',
  fileText: 'ri:file-text-line',
  film: 'ri:clapperboard-line',
  filter: 'ri:filter-3-line',
  folder: 'ri:folder-open-line',
  location: 'ri:landscape-line',
  help: 'ri:question-line',
  hidden: 'ri:eye-off-line',
  history: 'ri:history-line',
  home: 'ri:home-4-line',
  image: 'ri:image-line',
  info: 'ri:information-line',
  layout: 'ri:layout-grid-line',
  loading: 'ri:loader-4-line',
  lock: 'ri:lock-line',
  magic: 'ri:magic-line',
  menu: 'ri:more-2-line',
  minus: 'ri:subtract-line',
  model: 'ri:settings-5-line',
  music: 'ri:music-2-line',
  notification: 'ri:notification-3-line',
  phone: 'ri:smartphone-line',
  pin: 'ri:pushpin-line',
  play: 'ri:play-circle-line',
  pause: 'ri:pause-circle-line',
  preview: 'ri:eye-line',
  refresh: 'ri:refresh-line',
  robot: 'ri:robot-2-line',
  rocket: 'ri:rocket-line',
  script: 'ri:file-list-3-line',
  search: 'ri:search-line',
  security: 'ri:shield-check-line',
  settings: 'ri:settings-3-line',
  share: 'ri:share-forward-line',
  star: 'ri:star-line',
  story: 'ri:book-open-line',
  style: 'ri:palette-line',
  target: 'ri:focus-3-line',
  template: 'ri:fire-line',
  tip: 'ri:lightbulb-line',
  upload: 'ri:upload-2-line',
  user: 'ri:user-line',
  video: 'ri:movie-line',
  warning: 'ri:alert-line',
  weather: 'ri:sun-cloudy-line',
  zoomIn: 'ri:zoom-in-line',
  zoomOut: 'ri:zoom-out-line',
} as const;

export type RiIconName = keyof typeof riIconMap;

export function resolveRiIcon(name: RiIconName | string): string {
  return riIconMap[name as RiIconName] ?? name;
}
